import { BriefApplicationResponseDto } from "./briefs.dto";
import { CreatorResponseDto } from "./creators.dto";
import { PayoutProviderEnum } from "./wallet-transaction.dto";

export enum PayoutStatusEnum {
    All = 0,
    Created = 1,
    Succeeded = 2,
    Failed = 3,
    ProviderPreparing = 4,
    AwaitingCmApproval = 5,
    AwaitingApproval = 6,
    AwaitingFunds = 7,
    AwaitingUserConfirmation = 8,
    Sent = 10,
    InsufficientFunds = 11
}

export interface PayoutFilter {
    payoutStatus?: PayoutStatusEnum;
    countryCode?: string[],
    type?: PayoutTypeEnum;
    businessAccounts?: string[];
    briefApplicationId?: string;
}

export interface PayoutFilterCreator {
    startDate?: Date;
    endDate?: Date;
    skip: number;
    take: number;
}

export interface CreatorPayoutBalances {
    earnt: number;
    onItsWay: number;
}

/** Raw row shape from POST /payouts/creator/:creatorId */
export interface CreatorPayoutListItem {
    id?: string;
    amount: number;
    currencyCode: string;
    createdDate: Date | string;
    payoutStatus?: PayoutStatusEnum | number;
    provider?: PayoutProviderEnum | string;
    briefApplicationId?: string | null;
    walletTransactionId?: string | null;
    briefTitle?: string;
    companyName?: string;
    companyLogo?: string;
}

export enum PayoutTypeEnum {
    All = 0,
    BriefApplication = 1,
    Bonus = 2,
    CrossChannelPayment = 3,
    AdLicense = 4,
    /** Affiliate commission on a creator's locked sales, paid from the brand's wallet. */
    Commission = 5
}

export interface CreatePayoutRequestDto {
  blazeFirebaseUid: string;
  amount: number;
  briefAmount: number;
  briefCurrencyCode: string;
  conversionRate: number;
  currencyCode: string;
  commission: number;
  briefApplicationId: string;
  type: PayoutTypeEnum;
  rankMultiplier: number;
  provider: string;
  walletTransaction: { id: string };
}

export interface PayoutDto {
    id?: string;
    createdDate: Date;
    creator?: CreatorResponseDto;
    blazeFirebaseUid: string;
    amount: number;
    briefAmount: number;
    briefCurrencyCode: string;
    conversionRate: number;
    currencyCode: string;
    commission: number;
    briefApplicationId?: string;
    type?: PayoutTypeEnum;
    paidBy?: string;
    payoutStatus?: PayoutStatusEnum;
    rankMultiplier: number;
    briefApplication?: BriefApplicationResponseDto;
    payoutAttempts: any[];
    isProcessing: boolean;
    provider?: PayoutProviderEnum | string;
    /** Airwallex transfer id when the payout has completed with the provider. */
    finalProviderId?: string;
  }
  